const US = {
    moduleTitle: 'Support Services',
    list: [
        { title: 'Get Support', desc: 'Quickly access order support, technical support, and other services.' },
        { title: 'Service Status', desc: 'View service progress and track detailed updates.' },
        { title: 'Warranty Registration', desc: 'Register your product and activate the warranty.' },
        { title: 'After-sales Policy', desc: "View the terms of EcoFlow's After-sales Policy." },
        { title: 'Track Your Order', desc: 'Track your order and view shipping updates in real-time.' },
        { title: 'Frequently Asked Questions', desc: 'Browse frequently asked questions to find answers quickly.' },
        { title: 'Documentation and Manuals', desc: 'Access user manuals, video tutorials and other official documentation.' },
        { title: 'Contact Us', desc: 'Please contact us if you require assistance. We provide professional support and services.' },
        { title: 'EcoFlow App', desc: 'Monitor and control your power usage and set limits and modes.' },
        { title: 'Check Your Device Benefits', desc: 'Query product warranty period and protection services.' },
    ],
};

export const A_DATA: Record<
    string,
    {
        moduleTitle: string;
        list: { title: string; desc: string }[];
    }
> = {
    us: {
        ...US,
    },
    eu: {
        ...US,
    },
    uk: {
        ...US,
    },
    ca: {
        ...US,
    },
    au: {
        ...US,
    },
    za: {
        ...US,
    },
    cn: {
        moduleTitle: '热门服务',
        list: [
            { title: '获取服务', desc: '在线快速获得订单支持、技术支持等服务' },
            { title: '服务进度', desc: '获取服务进度并跟踪服务详情' },
            { title: '保修登记', desc: '注册您的产品，激活保修权益' },
            { title: '售后政策', desc: '快速查阅Ecoflow售后服务条款' },
            { title: '订单追踪', desc: '实时订单追踪，随时了解您的配送进度' },
            { title: '常见问题', desc: '快速浏览常见问题，轻松找到所需解答' },
            { title: '文档与手册', desc: '获取使用手册、视频教程等官方文档' },
            { title: '联系我们', desc: '如需帮助请联系我们，我们将为您提供专业的支持与服务' },
            { title: 'EcoFlow APP', desc: '全面监测并控制您的用电状态、参数和模式' },
            { title: '设备权益查询', desc: '设备权益查询' },
        ],
    },
    de: {
        moduleTitle: 'Allgemeine Dienstleistungen',
        list: [
            { title: 'Hilfe', desc: 'Zugang zu Online-Services wie Bestellung und technischen Support' },
            { title: 'Fortschritte überprüfen', desc: 'Service- und Auftragsverfolgung' },
            { title: 'Garantie Registrierung', desc: 'Produkt registrieren und Garantie aktivieren' },
            { title: 'After Sales Richtlinie', desc: 'Die Bedingungen der EcoFlow After Sales Richtlinie finden Sie hier' },
            { title: 'Bestellung nachverfolgen', desc: 'Verfolgen Sie Ihre Bestellung und Lieferstatus in Echtzeit.' },
            { title: 'Häufig gestellte Fragen', desc: 'Suchen Sie in den häufig gestellten Fragen. Hier finden Sie schnell Antworten.' },
            { title: 'Dokumentation und Handbücher', desc: 'Zugang zu Benutzerhandbüchern, Video-Tutorials und anderen offiziellen Dokumentation' },
            {
                title: 'Kontaktieren Sie uns',
                desc: 'Wenn Sie Hilfe benötigen, wenden Sie sich bitte an uns. Wir bieten professionelle Unterstützung und Services.',
            },
            { title: 'EcoFlow App', desc: 'Überwachen und steuern Sie Ihren Energieverbrauch, Ihre Parameter und Modi.' },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    fr: {
        moduleTitle: 'Services',
        list: [
            { title: "Obtenez de l'aide", desc: "Accédez à des services en ligne tels que l'assistance aux commandes et l'assistance technique." },
            { title: "Vérifiez l'état d'avancement", desc: "Suivez l'avancement du service et des commandes." },
            { title: 'Activez la garantie', desc: 'Enregistrez votre produit pour activer la garantie.' },
            { title: 'Politique après-vente', desc: "Consultez les conditions de la Politique après-vente d'EcoFlow." },
            { title: 'Suivez votre commande', desc: 'Suivez votre commande et consultez les mises à jour de livraison en temps réel.' },
            { title: 'Questions et réponses', desc: 'Consultez les questions fréquemment posées pour trouver rapidement des réponses.' },
            { title: 'Documentation et manuels', desc: "Accédez aux manuels d'utilisation, aux tutoriels vidéo et à d'autres documents officiels." },
            {
                title: 'Contactez-nous',
                desc: "Veuillez nous contacter si vous avez besoin d'aide. Nous offrons une assistance et des services professionnels.",
            },
            { title: 'Application EcoFlow', desc: "Surveillez et gérez votre consommation d'énergie, vos paramètres et vos modes." },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    it: {
        moduleTitle: 'Servizi comuni',
        list: [
            { title: 'Richiedi assistenza', desc: 'Accedi a servizi online quali supporto per gli ordini e assistenza tecnica.' },
            { title: 'Controlla l’avanzamento', desc: 'Monitora lo stato di avanzamento dei servizi e degli ordini.' },
            { title: 'Registrazione della garanzia', desc: 'Registra il tuo prodotto e attiva la garanzia.' },
            { title: 'Politica post-vendita', desc: 'Consulta i termini della Politica post-vendita di EcoFlow.' },
            { title: 'Monitora il tuo ordine', desc: 'Monitora il tuo ordine e visualizza gli aggiornamenti in tempo reale sulla spedizione.' },
            { title: 'Domande frequenti', desc: 'Sfoglia le domande poste più di frequente per trovare rapidamente risposte ai tuoi dubbi.' },
            { title: 'Documentazione e manuali', desc: 'Accedi ai manuali d’uso, ai video tutorial e a ulteriore documentazione ufficiale.' },
            { title: 'Contattaci', desc: 'Contattaci se hai bisogno di aiuto. Siamo a tua disposizione per fornirti assistenza e servizi professionali.' },
            { title: 'App EcoFlow', desc: 'Tieni sotto controllo e gestisci i tuoi consumi energetici e i parametri e le modalità di alimentazione.' },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    es: {
        moduleTitle: 'Servicios generales',
        list: [
            { title: 'Obtener ayuda', desc: 'Accede a servicios en línea como asistencia para pedidos y soporte técnico.' },
            { title: 'Comprobar el progreso', desc: 'Sigue el progreso de tu pedido y servicio.' },
            { title: 'Registro de garantía', desc: 'Registra tu producto y activa la garantía.' },
            { title: 'Política de posventa', desc: 'Consulta los términos de la política de posventa de EcoFlow.' },
            {
                title: 'Realiza el seguimiento de tu pedido',
                desc: 'Realiza el seguimiento de tu pedido y consulta las actualizaciones de envío en tiempo real.',
            },
            { title: 'Preguntas frecuentes', desc: 'Consulta las preguntas frecuentes para obtener respuestas rápidamente.' },
            { title: 'Documentación y manuales', desc: 'Accede a manuales de usuario, videotutoriales y otra documentación oficial.' },
            { title: 'Contáctanos', desc: 'Ponte en contacto con nosotros si necesitas asistencia. Brindamos soporte y servicios profesionales.' },
            { title: 'Aplicación EcoFlow', desc: 'Supervisa y controla tu consumo de energía, parámetros y modos.' },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    jp: {
        moduleTitle: '一般サービス',
        list: [
            { title: 'サポートを取得', desc: '注文サポートやテクニカルサポートなどのオンラインサービスへのアクセス' },
            { title: '進捗状況の確認', desc: 'サービスおよび注文の進捗状況の追跡' },
            { title: '保証登録', desc: '製品の登録と保証の有効化' },
            { title: 'アフターサービスポリシー', desc: 'EcoFlow アフターサービスポリシーの規約を表示' },
            { title: '注文の追跡', desc: '注文の追跡および配送状況をリアルタイムで確認' },
            { title: 'よくあるご質問', desc: 'よくある質問を閲覧して、回答をすばやく検索' },
            { title: 'ドキュメントおよびマニュアル', desc: 'ユーザーマニュアル、ビデオチュートリアル、その他の公式ドキュメントへのアクセス' },
            { title: 'お問い合わせ', desc: 'サポートが必要な場合は、お問い合わせください。プロフェッショナルなサポートとサービスを提供します。' },
            { title: 'EcoFlow アプリ', desc: '電力使用量、パラメーター、モードを監視および制御します。' },
            { title: '製品保証期間と特典の確認', desc: '製品の保証期間と保護サービスに関するお問い合わせはこちら' },
        ],
    },
    kr: {
        moduleTitle: '일반 서비스',
        list: [
            { title: '지원 받기', desc: '주문 지원 및 기술 지원과 같은 온라인 서비스에 액세스' },
            { title: '진행 상황 확인', desc: '서비스 및 주문 진행 상황 추적' },
            { title: '보증 등록', desc: '제품 등록 및 보증 활성화' },
            { title: 'AS 정책', desc: 'EcoFlow의 AS 정책 조건 보기' },
            { title: '주문 추적', desc: '주문을 추적하고 실시간으로 배송 업데이트 보기' },
            { title: '자주 묻는 질문', desc: '자주 묻는 질문을 탐색하여 빠르게 답변 찾기' },
            { title: '문서 및 설명서', desc: '사용 설명서, 비디오 튜토리얼 및 기타 공식 문서에 액세스' },
            { title: '문의하기', desc: '도움이 필요하면 당사에 문의하세요. 전문적인 지원 및 서비스를 제공합니다.' },
            { title: 'EcoFlow 앱', desc: '전력 사용량, 매개변수 및 모드를 모니터링하고 제어합니다.' },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    sa: {
        moduleTitle: 'الخدمات المشتركة',
        list: [
            { title: 'الحصول على المساعدة', desc: 'الوصول إلى الخدمات عبر الإنترنت مثل دعم الطلبات والدعم الفني' },
            { title: 'التحقق من التقدم المحرز', desc: 'تتبع مستوى تقدم الخدمة والطلبات' },
            { title: 'تسجيل الضمان', desc: 'سجّل منتجك وفعّل الضمان' },
            { title: 'سياسة خدمات ما بعد البيع', desc: 'عرض شروط سياسة ما بعد البيع الخاصة بشركة EcoFlow' },
            { title: 'تتبع طلبك', desc: 'تتبع طلبك وعرض تحديثات الشحن في الوقت الحقيقي' },
            { title: 'الأسئلة الشائعة', desc: 'تصفح الأسئلة الشائعة للعثور على إجابات سريعة' },
            { title: 'الوثائق والأدلة الإرشادية', desc: 'الوصول إلى الأدلة الإرشادية للمستخدم والفيديوهات التعليمية والمستندات الرسمية الأخرى' },
            { title: 'تواصل معنا', desc: 'يُرجى الاتصال بنا إذا كنت بحاجة إلى مساعدة. نحن نقدم الدعم والخدمات الاحترافية.' },
            { title: 'تطبيق EcoFlow', desc: 'راقب استخدام الطاقة ومعلماتها وأوضاعها وتحكم في استخدامها.' },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    tw: {
        moduleTitle: '常態服務',
        list: [
            { title: '求助', desc: '獲得線上服務如訂單支援和技術支援' },
            { title: '查看進度', desc: '追蹤服務和訂單進度' },
            { title: '保固期登記', desc: '登記您的產品並啟動保固期' },
            { title: '售後政策', desc: '檢視 EcoFlow 的售後政策條款' },
            { title: '追蹤您的訂單', desc: '追蹤您的訂單並即使檢視出貨更新' },
            { title: '常見問題 (FAQ)', desc: '快速瀏覽常見問題尋找答案' },
            { title: '文件與使用手冊', desc: '獲得用戶手冊、教學影片和其他正式文件' },
            { title: '洽詢管道', desc: '如果您需要協助請隨時連絡我們。我們提供專業的支援與服務。' },
            { title: 'EcoFlow App', desc: '監控您的用電量、參數與模式。' },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    br: {
        moduleTitle: 'Serviços de suporte',
        list: [
            { title: 'Get Support', desc: 'Quickly access order support, technical support, and other services.' },
            { title: 'Service Status', desc: 'View service progress and track detailed updates.' },
            { title: 'Warranty Registration', desc: 'Register your product and activate the warranty.' },
            { title: 'Política de pós-venda', desc: 'Confira os termos da Política de pós-venda da EcoFlow.' },
            { title: 'Track Your Order', desc: 'Track your order and view shipping updates in real-time.' },
            { title: 'Perguntas frequentes', desc: 'Confira as perguntas frequentes para encontrar respostas rapidamente.' },
            { title: 'Documentação e manuais', desc: 'Acesse os manuais do usuário, tutoriais em vídeo e outras documentações oficiais.' },
            { title: 'Entre em contato conosco', desc: 'Entre em contato conosco se precisar de assistência. Fornecemos suporte e serviços profissionais.' },
            { title: 'EcoFlow App', desc: 'Monitor and control your power usage and set limits and modes.' },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    mx: {
        moduleTitle: 'Servicios generales',
        list: [
            { title: 'Obtener ayuda', desc: 'Accede a servicios en línea como asistencia para pedidos y soporte técnico.' },
            { title: 'Comprobar el progreso', desc: 'Sigue el progreso de tu pedido y servicio.' },
            { title: 'Registro de garantía', desc: 'Registra tu producto y activa la garantía.' },
            { title: 'Política de posventa', desc: 'Consulta los términos de la política de posventa de EcoFlow.' },
            {
                title: 'Realiza el seguimiento de tu pedido',
                desc: 'Realiza el seguimiento de tu pedido y consulta las actualizaciones de envío en tiempo real.',
            },
            { title: 'Preguntas frecuentes', desc: 'Consulta las preguntas frecuentes para obtener respuestas rápidamente.' },
            { title: 'Documentación y manuales', desc: 'Accede a manuales de usuario, videotutoriales y otra documentación oficial.' },
            { title: 'Contáctanos', desc: 'Ponte en contacto con nosotros si necesitas asistencia. Brindamos soporte y servicios profesionales.' },
            { title: 'Aplicación EcoFlow', desc: 'Supervisa y controla tu consumo de energía, parámetros y modos.' },
            { title: 'Check your device benefits', desc: 'Check your device benefits' },
        ],
    },
    ph: {
        ...US,
    },
    nl: {
        moduleTitle: 'Ondersteunende diensten',
        list: [
            { title: 'Krijg ondersteuning', desc: 'Krijg snel toegang tot ondersteuning voor bestellingen, technische ondersteuning en andere diensten.' },
            { title: 'Servicestatus', desc: 'Bekijk de voortgang van de service en volg gedetailleerde updates.' },
            { title: 'Garantie registratie', desc: 'Registreer uw product en activeer de garantie.' },
            { title: 'After-sales Policy', desc: 'Garantiebeleid' },
            { title: 'Volg uw bestelling', desc: 'Volg uw bestelling en bekijk verzendupdates in realtime.' },
            { title: 'Veelgestelde vragen', desc: 'Bekijk de veelgestelde vragen om snel antwoorden te vinden.' },
            { title: 'Documentation and Manuals', desc: 'Documentatie en handleidingen' },
            {
                title: 'Neem contact met ons op',
                desc: 'Neem gerust contact met ons op als u hulp nodig heeft. Wij bieden professionele ondersteuning en diensten.',
            },
            { title: 'EcoFlow-app', desc: 'Bewaak en beheer uw energieverbruik en stel limieten en modi in.' },
            { title: 'Controleer de voordelen van uw apparaat.', desc: 'Vraag de productgarantieperiode en de beschikbare beschermingsdiensten op.' },
        ],
    },
};
